import * as React from 'react'

import { cn } from '#app/utils/misc.tsx'

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          'rounded-3 border-mauve-6 text-2 text-mauve-12 shadow-1 ring-offset-background placeholder:text-mauve-9 focus-visible:ring-ring disabled:bg-mauve-3 aria-[invalid]:border-input-invalid flex min-h-[80px] w-full border bg-white p-3 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:cursor-not-allowed',
          className,
        )}
        ref={ref}
        {...props}
      />
    )
  },
)
Textarea.displayName = 'Textarea'

export { Textarea }
